import React from 'react';
import styled from 'styled-components';
import { sidebarColours } from './common_styles';

/**
 * CSS-only solution.
 * - Primary: container queries (component adapts to its own width).
 * - Fallback: no @container? Use an ancestor width-attribute hack on MUI Drawer Paper.
 *   (We key off the inline style width you already set via PaperProps.)
 */

const MINI_PX = 72;   // match DRAWER_MINI

const Row = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    margin: 2px 0;
    padding: 0 16px;
    box-sizing: border-box;

    /* Let children run container queries against this row's width */
    container-type: inline-size;
    width: 100%;
    min-width: 0;
`;

const Label = styled.span`
    text-transform: uppercase;
    font-size: 11px;
    color: ${sidebarColours.textSubtle};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: 0.4px;
    line-height: 1;
    width: 100%;

   

    .MuiDrawer-paper[style*="width: ${MINI_PX}px"] & { display: none; }
    .MuiDrawer-paper[style*="width: 50px"] & { display: none; }
`;

const DotWrap = styled.div`
    display: none;
    align-items: center;
    justify-content: center;
    width: 100%;

    .MuiDrawer-paper[style*="width: ${MINI_PX}px"] & { display: flex; }
    .MuiDrawer-paper[style*="width: 50px"] & { display: flex; }
`;

const Dot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgba(148, 163, 184, 0.55);
`;

export default function SectionHeader({ children, hidden }) {
    if (hidden) return null;
    const title = typeof children === 'string' ? children : undefined;

    return (
        <Row title={title} aria-label={title || 'Section'}>
            <Label>{children}</Label>
            <DotWrap aria-hidden="true">
                <Dot />
            </DotWrap>
        </Row>
    );
}
